import { api } from "../http";
import { pagination } from "../interfaces/baseinterface";
import {
  ActiveStudent,
  ApiResponse,
  RevenueData,
  Student,
  StudentEnquiry,
  StudentPaymentRequest,
  UpcomingPayment,
} from "../types";
import {
  StudentSeatAllotment,
  StudentRegistrationData,
} from "../interfaces/StudentInterface";

export const getStudentDetails = async (): Promise<ApiResponse<Student[]>> => {
  try {
    const response = await api.get<ApiResponse<Student[]>>(
      "/Student/StudentSeatAllotment"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};

export const getActiveStudentDetails = async (): Promise<
  ApiResponse<ActiveStudent[]>
> => {
  try {
    const response = await api.get<ApiResponse<ActiveStudent[]>>(
      "/Student/GetActiveStudentList"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};

export const AllotSeatToStudent = async (
  student: Student
): Promise<ApiResponse<string>> => {
  try {
    const response = await api.post<ApiResponse<string>>(
      "/Student/AllotSeatToStudent",
      student
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};

export const getUnAllottedStudentDetails = async (): Promise<
  ApiResponse<Student[]>
> => {
  try {
    const response = await api.get<ApiResponse<Student[]>>(
      "/Student/GetUnAllotmentedStudent"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student details:", error);
    throw error;
  }
};

export const addStudentEnquiry = async (studentEnquiry: StudentEnquiry) => {
  try {
    const response = await api.post(
      "/Student/AddStudentEnquiry",
      studentEnquiry
    );
    return response.data;
  } catch (error) {
    console.error("Error adding student enquiry:", error);
    throw error;
  }
};

export const getStudentEnquiries = async (
  isDashBoard: boolean
): Promise<ApiResponse<StudentEnquiry[]>> => {
  try {
    const response = await api.post<ApiResponse<StudentEnquiry[]>>(
      `/Student/GetStudentEnquiry?isDashBoard=${isDashBoard}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student enquiries:", error);
    throw error;
  }
};

export const updateFollowUp = async (
  mobileNumber: string
): Promise<ApiResponse<string>> => {
  try {
    debugger;
    const response = await api.post<ApiResponse<string>>(
      `/Student/FollowUp?mobileNumber=${mobileNumber}`
    );
    return response.data;
  } catch (error) {
    console.error("Error Updating Follow Up", error);
    throw error;
  }
};

// Make sure `photo` is a File (from <input type="file">) in your StudentRegistrationData
export const registerStudent = async (
  student: StudentRegistrationData
): Promise<ApiResponse<string>> => {
  const form = new FormData();

  // Field names should match your C# model property names (case-insensitive for simple props)
  form.append("FirstName", student.firstName);
  form.append("LastName", student.lastName);
  form.append("EmailId", student.emailId);
  form.append("AadharNumber", student.aadharNumber);
  form.append("OptionalIdentification", student.optionalIdentification ?? "");
  form.append("MobileNumber", student.mobileNumber);
  form.append("AlternateNumber", student.alternateNumber ?? "");
  form.append("GuardianName", student.guardianName);
  form.append("GuardianMobileNumber", student.guardianMobileNumber);
  form.append("GenderCode", student.genderCode);
  form.append("Address", student.address);
  form.append("JoiningDate", student.joiningDate);
  if (student.amount) {
    form.append("Amount", student.amount);
  }
  if (student.validityFrom) {
    form.append("ValidityFrom", student.validityFrom);
  }
  if (student.validityTo) {
    form.append("ValidityTo", student.validityTo);
  }
  form.append("RecordPayment", "true");

  if (student.photo) {
    // 'Photo' must match the IFormFile property name on the server
    form.append(
      "Photo",
      student.photo,
      student.photo.name || `student_${Date.now()}.jpg`
    );
  }

  // IMPORTANT: let Axios set the Content-Type with the boundary automatically
  const response = await api.post<ApiResponse<string>>(
    "/Student/StudentRegistration",
    form
    // , { headers: { "Content-Type": "multipart/form-data" } } // optional, usually omit
  );

  return response.data;
};

export const getStudentValidation = async (
  field: string,
  value: string
): Promise<ApiResponse<number>> => {
  try {
    const response = await api.get<ApiResponse<number>>(
      `/Student/Validation?field=${field}&value=${value}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student enquiries:", error);
    throw error;
  }
};

export const getStudentAllotment = async (
  pagination: pagination
): Promise<ApiResponse<StudentSeatAllotment[]>> => {
  try {
    const response = await api.post<ApiResponse<StudentSeatAllotment[]>>(
      "Student/GetStudentAllotment",
      pagination
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student enquiries:", error);
    throw error;
  }
};

export const updateStudentStatus = async (
  studentId: number,
  isActive: boolean
): Promise<ApiResponse<string>> => {
  try {
    const response = await api.post<ApiResponse<string>>(
      `/Student/UpdateStudentStatus?studentId=${studentId}&isActive=${isActive}`
    );
    return response.data;
  } catch (error) {
    console.error("Error updating student status:", error);
    throw error;
  }
};

export const saveStudentPayment = async (
  studentPaymentRequest: StudentPaymentRequest
): Promise<ApiResponse<string>> => {
  try {
    const response = await api.post<ApiResponse<string>>(
      "/Student/SavePayment",
      studentPaymentRequest
    );
    return response.data;
  } catch (error) {
    console.error("Error updating student status:", error);
    throw error;
  }
};

export const getRevenueData = async (): Promise<ApiResponse<RevenueData>> => {
  try {
    const response = await api.get<ApiResponse<RevenueData>>(
      "/Student/GetRevenueData"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching revenue data:", error);
    throw error;
  }
};

export const getUpcomingPayments = async (): Promise<
  ApiResponse<UpcomingPayment[]>
> => {
  try {
    const response = await api.get<ApiResponse<UpcomingPayment[]>>(
      "/Student/GetUpcomingPayments"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching upcoming payments:", error);
    throw error;
  }
};
